<div class="container">
  <div class="text-center">
    <h2>
      <strong class="mainHeading slide-in-left">Baldia Dashboard</strong>
    </h2>
  </div>

  <div class="row">
    <div class="col-md-2">
      <div class="card shadow-lg">
        <div
          class="card d-flex flex-column justify-content-center align-items-center text-center p-3"
        >
          <div>
            <strong
              ><h1 class="mb-1">{{ allCount?.cityCount }}</h1></strong
            >
          </div>
          <div>
            <h3 class="mb-0">City</h3>
          </div>
        </div>
      </div>
      <div class="card shadow-lg mt-3">
        <div
          class="card d-flex flex-column justify-content-center align-items-center text-center p-3"
        >
          <div>
            <strong
              ><h1 class="mb-1">{{ allCount?.zoneCount }}</h1></strong
            >
          </div>
          <div>
            <h3 class="mb-0">Zones</h3>
          </div>
        </div>
      </div>
      <div class="card shadow-lg mt-3">
        <div
          class="card d-flex flex-column justify-content-center align-items-center text-center p-3"
        >
          <div>
            <strong
              ><h1 class="mb-1">{{ allCount?.registeredUsers }}</h1></strong
            >
          </div>
          <div>
            <h3 class="mb-0">Registered Users</h3>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-10">
      <div class="row">
        <div class="col-md-6">
          <div class="card shadow-lg position-relative">
            <div class="modal-header custom-modal-header">
              <h3 class="modal-title mt-3 ms-1">Individual Requestor</h3>
            </div>
            <div class="m-2 d-flex">
              <div class="me-2">
                <select class="form-select" (change)="onCityChange($event, 1)">
                  <option value="">All</option>
                  <option *ngFor="let city of cityList" [value]="city.id">
                    {{ city.cityName }}
                  </option>
                </select>
              </div>

              <!-- Zone Select Box -->
              <div>
                <select
                  class="form-select"
                  aria-label="Select Zone"
                  (change)="onZoneChange($event, 1)"
                >
                  <option value="" selected>All</option>
                  <option
                    *ngFor="let zone of zoneListIndividual"
                    [value]="zone.zoneId"
                  >
                    {{ zone.zoneName }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Chart -->
            <div id="chart">
              <apx-chart
                *ngIf="
                  individualChartOptions.series &&
                  individualChartOptions.series.length > 0
                "
                [series]="individualChartOptions.series"
                [chart]="individualChartOptions.chart"
                [dataLabels]="individualChartOptions.dataLabels"
                [stroke]="individualChartOptions.stroke"
                [colors]="individualChartOptions.colors"
                [title]="individualChartOptions.title"
                [subtitle]="individualChartOptions.subtitle"
                [plotOptions]="individualChartOptions.plotOptions"
                [yaxis]="individualChartOptions.yaxis"
                [xaxis]="individualChartOptions.xaxis"
                [tooltip]="individualChartOptions.tooltip"
              ></apx-chart>
            </div>
          </div>
        </div>

        <!-- Second Card - Corporate Chart -->
        <div class="col-md-6">
          <div class="card shadow-lg">
            <div class="modal-header custom-modal-header">
              <h3 class="modal-title mt-3 ms-1">Corporate Requestor</h3>
            </div>
            <div class="m-2 d-flex">
              <div class="me-2">
                <select
                  class="form-select"
                  aria-label="Select City"
                  (change)="onCityChange($event, 2)"
                >
                  <option value="" selected>All</option>
                  <option *ngFor="let city of cityList" [value]="city.id">
                    {{ city.cityName }}
                  </option>
                </select>
              </div>

              <!-- Zone Select Box -->
              <div>
                <select
                  class="form-select"
                  aria-label="Select Zone"
                  (change)="onZoneChange($event, 2)"
                >
                  <option value="" selected>All</option>
                  <option
                    *ngFor="let zone of zoneListCorporate"
                    [value]="zone.zoneId"
                  >
                    {{ zone.zoneName }}
                  </option>
                </select>
              </div>
            </div>
            <div id="chart">
              <apx-chart
                *ngIf="
                  corporateChartOptions.series &&
                  corporateChartOptions.series.length > 0
                "
                [series]="corporateChartOptions.series"
                [chart]="corporateChartOptions.chart"
                [dataLabels]="corporateChartOptions.dataLabels"
                [stroke]="corporateChartOptions.stroke"
                [colors]="corporateChartOptions.colors"
                [title]="corporateChartOptions.title"
                [subtitle]="corporateChartOptions.subtitle"
                [plotOptions]="corporateChartOptions.plotOptions"
                [yaxis]="corporateChartOptions.yaxis"
                [xaxis]="corporateChartOptions.xaxis"
                [tooltip]="corporateChartOptions.tooltip"
              ></apx-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-2">
      <div class="card shadow-lg mt-3">
        <div
          class="card d-flex flex-column justify-content-center align-items-center text-center p-3"
        >
          <div>
            <strong
              ><h1 class="mb-1">{{ allCount?.onBusiness }}</h1></strong
            >
          </div>
          <div>
            <h3 class="mb-0">On Buisness</h3>
          </div>
        </div>
      </div>
      <div class="card shadow-lg mt-3">
        <div
          class="card d-flex flex-column justify-content-center align-items-center text-center p-3"
        >
          <div>
            <strong
              ><h1 class="mb-1">{{ allCount?.offBusiness }}</h1></strong
            >
          </div>
          <div>
            <h3 class="mb-0">Off Buisness</h3>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-10">
      <div class="row">
        <div class="col-md-6">
          <div class="card shadow-lg">
            <div class="modal-header custom-modal-header">
              <h3 class="modal-title mt-3 ms-1">Dumpster Users</h3>
            </div>
            <div class="m-2 d-flex">
              <div class="me-2">
                <select
                  class="form-select"
                  aria-label="Select City"
                  (change)="onCityChange($event, 3)"
                >
                  <option value="" selected>All</option>
                  <option *ngFor="let city of cityList" [value]="city.id">
                    {{ city.cityName }}
                  </option>
                </select>
              </div>

              <!-- Zone Select Box -->
              <div>
                <select
                  class="form-select"
                  aria-label="Select Zone"
                  (change)="onZoneChange($event, 3)"
                >
                  <option value="" selected>All</option>
                  <option
                    *ngFor="let zone of zoneListDumpster"
                    [value]="zone.zoneId"
                  >
                    {{ zone.zoneName }}
                  </option>
                </select>
              </div>
            </div>
            <div id="chart">
              <apx-chart
                *ngIf="
                  dumpsterChartOptions.series &&
                  dumpsterChartOptions.series.length > 0
                "
                [series]="dumpsterChartOptions.series"
                [chart]="dumpsterChartOptions.chart"
                [dataLabels]="dumpsterChartOptions.dataLabels"
                [stroke]="dumpsterChartOptions.stroke"
                [colors]="dumpsterChartOptions.colors"
                [title]="dumpsterChartOptions.title"
                [subtitle]="dumpsterChartOptions.subtitle"
                [plotOptions]="dumpsterChartOptions.plotOptions"
                [yaxis]="dumpsterChartOptions.yaxis"
                [xaxis]="dumpsterChartOptions.xaxis"
                [tooltip]="dumpsterChartOptions.tooltip"
              ></apx-chart>
            </div>
          </div>
        </div>

        <!-- Second Card - Corporate Chart -->
        <div class="col-md-6">
          <div class="card shadow-lg">
            <div class="modal-header custom-modal-header">
              <h3 class="modal-title mt-3 ms-1">Dumpyard Users</h3>
            </div>
            <div class="m-2 d-flex">
              <div class="me-2">
                <select
                  class="form-select"
                  aria-label="Select City"
                  (change)="onCityChange($event, 4)"
                >
                  <option value="" selected>All</option>
                  <option *ngFor="let city of cityList" [value]="city.id">
                    {{ city.cityName }}
                  </option>
                </select>
              </div>

              <!-- Zone Select Box -->
              <div>
                <select
                  class="form-select"
                  aria-label="Select Zone"
                  (change)="onZoneChange($event, 4)"
                >
                  <option value="" selected>All</option>
                  <option
                    *ngFor="let zone of zoneListDumpyard"
                    [value]="zone.zoneId"
                  >
                    {{ zone.zoneName }}
                  </option>
                </select>
              </div>
            </div>
            <div id="chart">
              <apx-chart
                *ngIf="
                  dumpyardChartOptions.series &&
                  dumpyardChartOptions.series.length > 0
                "
                [series]="dumpyardChartOptions.series"
                [chart]="dumpyardChartOptions.chart"
                [dataLabels]="dumpyardChartOptions.dataLabels"
                [stroke]="dumpyardChartOptions.stroke"
                [colors]="dumpyardChartOptions.colors"
                [title]="dumpyardChartOptions.title"
                [subtitle]="dumpyardChartOptions.subtitle"
                [plotOptions]="dumpyardChartOptions.plotOptions"
                [yaxis]="dumpyardChartOptions.yaxis"
                [xaxis]="dumpyardChartOptions.xaxis"
                [tooltip]="dumpyardChartOptions.tooltip"
              ></apx-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
